<template>
    <div>
        <div class="container">      
            <div class="d-flex"> 
                <div  class="btn-home-2 mb-2 mt-3 ms-auto">
                    <button type="button" class="btn btn-outline-main" @click="returnHome">
                        <i class="fas fa-home-lg-alt"></i> Inicio
                    </button>
                </div>
            </div>

            <ul class="nav pb-0" id="myTab" role="tablist">
                <li class="nav-item  " role="presentation">
                    <button
                      @click="changePage('productos')" 
                      :class="{'item-button':true, 'nav-link': true, 'active': page === 'productos' }"
                      id="home-tab" 
                      type="button" 
                     >
                       <strong>PRODUCTOS</strong> 
                    </button>
                </li>
                <li class="nav-item  " role="presentation">
                    <button
                      @click="changePage('metodos')" 
                      :class="{'item-button':true, 'nav-link': true, 'active': page === 'metodos' }"
                      id="home-tab" 
                      type="button" 
                     >
                       <strong>METODOS PAGO</strong> 
                    </button>
                </li>
                <li class="nav-item  " role="presentation">
                    <button
                      @click="changePage('provider')" 
                      :class="{'item-button':true, 'nav-link': true, 'active': page === 'provider' }"
                      id="home-tab" 
                      type="button" 
                     >
                        <strong>PROVEEDORES</strong> 
                    </button>
                </li>
            </ul>
            <div class="tab-content border border-main mb-4 p-2" style="height: 50%;" >
                <ProductosVue  class="mt-2" v-if="page == 'productos'" />
                <MetodosVue  class="mt-2" v-if="page == 'metodos'" />
                <ProveedoresVue v-if="page == 'provider'" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import ProductosVue from "./Mantenimiento/Productos.vue";
import MetodosVue from "./Mantenimiento/Metodos.vue";
import ProveedoresVue from "./Mantenimiento/Proveedores.vue";
export default {

name:"logis-maintenance",
components:{
    SweetAlert,
    ProductosVue,
    MetodosVue,
    ProveedoresVue
},
data(){
    return{
        page: "productos",
    }
  },
created() {
},
 methods:{
    ...mapActions(["get", "post"]),

    changePage: function (page) {
      this.page = page;
    },
    returnHome: function () {
      this.$emit("returnHome");
    },
 }
}
</script>

<style scoped>
.h4-borde{
    border-radius: 50px;
}
#myTabContent{
    border:#2c3c5c 1.9px solid;
}

.item-button{
    background: #A9A9A9 !important;
    border-radius: 10px 10px 0px 0px;   
    border: none !important;
    color:white !important;
    width: 155px;   
}
.item-button1{
    background: #A9A9A9 !important;
    border-radius: 10px 10px 0px 0px;   
    border: none !important;
    color:white !important;
    width: 160px !important;    
}

.nav-link:hover{
    background:#2c3c5c !important
}
.active {
  background-color: #2c3c5c !important ;
 
}
.nav-item{
    width: 159.39px;
}
</style>